import styled from 'styled-components';
import { Layout } from 'antd';

const { Content } = Layout;

export const LayoutContainer = styled.div`
  min-height: 100vh;
  background: #f5f5f5;
`;

export const ContentArea = styled(Content)`
  background: #f5f5f5;
  min-height: calc(100vh - 64px);
  margin-left: 80px; /* Espace pour sidebar fermée */
  margin-top: 64px;
  transition: margin-left 0.2s;
  
  /* Ajuster la marge selon l'état de la sidebar */
  .ant-layout-sider-collapsed + & {
    margin-left: 80px;
  }
  
  .ant-layout-sider:not(.ant-layout-sider-collapsed) + & {
    margin-left: 280px;
  }
`;

export const MainContent = styled.div`
  padding: 24px;
  min-height: calc(100vh - 112px);
`;